import { Button, Form, message, Input, Col, Row } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import recommendedAppApis from 'api/recommendedAppApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat } from 'helpers/dateTimeHelper';

export default function ListRecommendedAppsPage() {

  const [recommendedApps, setRecommendedApps] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  async function fetchRecommendedApps(params={}) {
    setIsFetching(true);
    try {
      const res = await recommendedAppApis.listing(params);
      if (res.code === 200) {
        setRecommendedApps(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchRecommendedApps()
  }, []);

  const onChangeTable = async(pagination, filters, sorter) => {
    console.log(sorter)
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchRecommendedApps(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    console.log(params)
    await fetchRecommendedApps(params)
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'app_id',
      width: '15rem',
      render: (record) => <span>{record.app_id}</span>
    },
    {
      title: 'description',
      width: '7rem',
      render: (record) => <span>{record.description}</span>
    },
    {
      title: 'copyright',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.copyright}</span>
    },
    {
      title: 'privacy_policy',
      width: '10rem',
      render: (record) => <span>{record.privacy_policy}</span>
    },
    {
      title: 'category',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.category}</span>
    },
    {
      title: 'position',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.position}</span>
    },
    {
      title: 'is_listed',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.is_listed}</span>
    },
    {
      title: 'install_count',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.install_count}</span>
    },
    {
      title: 'created_at',
      width: '10rem',
      key: 'created_at',
      sorter: true,
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả recommendedApps"
        pageHeaderExtras={
          <>
            <Button type="primary">
              Thêm
            </Button>
          </>
        }
      />
      <br />
      <ContentRow capped>
      <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='app_id'
                label='app_id'
              >
                <Input placeholder="Tìm theo app_id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='category'
                label='category'
              >
                <Input placeholder="Tìm theo category" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          // @ts-ignore
          columns={columns}
          dataSource={recommendedApps}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}
